import { manufacturingFetch } from "@/lib/manufacturingClient";

export type LogiShipment = {
  id: string;
  code: string;
  origin_code: string;
  parent_shipment_id: string | null;
  rearrangement_suffix: string | null;
  split_reason: string;
};

export function listLogisticsShipments() {
  return manufacturingFetch<{
    ok: true;
    shipments: LogiShipment[];
    missing_table: boolean;
  }>("/api/logi/shipments", { method: "GET" });
}

export function splitLogisticsShipment(unitId: string, splitReason?: string) {
  return manufacturingFetch<{ ok: true; shipment: LogiShipment; unit_id: string }>(
    "/api/logi/shipments/split",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ unit_id: unitId, split_reason: splitReason ?? "" }),
    }
  );
}
